import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

class AdminProductionsViewRoute extends Route {
  @service api;
  @service store;

  async model({ slug }) {
    const response = await this.api.get(`productions/${slug}`, {
      params: {
        include: 'client,invoices,postings,projects',
      },
    });
    this.store.pushPayload(response);
    return this.store.peekRecord('production', response.data.id);
  }
}

export default AdminProductionsViewRoute;
